import type { ActionFunctionArgs } from '~/types/route-args';
import { data as routerData } from 'react-router';
import { z } from 'zod';
import { updateDesignBoardSettings } from '~/modules/settings/api/update-design-board-settings.server';

export const UPDATE_NOTIFICATION_SETTINGS_API =
    '/remix-api/settings/notifications';

const FORM_DATA_SCHEMA = z.object({
    enquiryReminderEmailEnabled: z.boolean(),
});

/**
 * API endpoint to update the current user's notification settings.
 * @see {@link packages/web/app/modules/settings/hooks/use-notification-settings.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return routerData(null, { status: 400 });
    }

    try {
        const response = await updateDesignBoardSettings({
            context,
            enquiryReminderEmailEnabled:
                result.data.enquiryReminderEmailEnabled,
        });

        if (!response) {
            return routerData(null, { status: 500 });
        }

        const { __typename: _, ...setting } = response;

        return { settings: setting };
    } catch (error) {
        logger.error(`Error in ${UPDATE_NOTIFICATION_SETTINGS_API}`, {
            error,
            data: result.data,
        });
        return routerData(null, { status: 500 });
    }
};
